import styled from 'styled-components'
import { VARIABLES } from '../../themes'
// import {
//   default as VARIABLES
// } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const SupplierDiscoveryStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  .main-content {
    position: relative;
    padding: 60px 0;
    //min-width: 1450px;

    .content-body {
      flex-wrap: nowrap;
      align-content: flex-start;
      align-items: flex-start;

      .year-established-filter {
        input:disabled {
          background-color: white;
        }
      }

      .select-control {
        position: relative;
        .select-icon {
          position: absolute;
          right: 9px;
          top: 7px;
          width: 20px;
        }
      }
    }
  }

  /* Start supplier-discovery  */
  .supplier-header {
    display: flex;
    width: 100%;
    margin-bottom: 30px;
    position: relative;
  }

  .supplier-name-and-signs {
    display: flex;
    gap: 10px;
  }

  .supplier-name-and-address {
    padding-right: 100px;
    flex: 1;
  }

  .supplier-address {
    /* width: 100%; */
    font-size: 14px;
    color: #595959;
    /* display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    max-height: calc(42px);
    overflow: hidden; */
  }

  .supplier-name {
    font-size: 20px;
    color: #4b4acb;
    font-weight: 600;
    cursor: pointer;
    max-width: 65%;
    flex: none;
  }

  .supplier-info {
    display: flex;
    width: 100%;
    color: ${VARIABLES.COLORS.BLUE_1};
    flex-wrap: wrap;
    column-gap: 10px;

    .col {
      flex: 1;
    }

    .fluid {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }

  .info-block {
    display: flex;
    margin-bottom: 5px;
    gap: 10px;

    .label {
      flex: 0 0 165px;
      font-weight: 500;
    }
  }
  /* End supplier-discovery  */

  .scoreboard {
    width: 100px;
    height: 100px;
    position: absolute;
    right: 0;
  }

  .supplier-list-wrapper {
    position: relative;
    margin-top: -60px;
    padding: 60px 0;

    &::before {
      position: absolute;
      width: 1px;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 1;
      background-color: #f0f0f4;
      content: '';
    }
  }

  .search-note {
    color: ${VARIABLES.COLORS.GRAY_10};
  }

  .list-render:focus {
    outline: none;
  }

  /* Start status risk lavel  */
  .status-risk {
    width: 14px;
    height: 14px;
    display: inline-block;
    border-radius: 30px;
    vertical-align: middle;

    &.green {
      background-color: ${VARIABLES.COLORS.GREEN_1};
    }

    &.green-light {
      background-color: ${VARIABLES.COLORS.GREEN_8};
    }

    &.yellow {
      background-color: ${VARIABLES.COLORS.YELLOW_3};
    }

    &.orange {
      background-color: ${VARIABLES.COLORS.ORANGE_2};
    }

    &.red {
      background-color: ${VARIABLES.COLORS.RED_5};
    }
  }
  /* End status risk lavel  */

  .registered-capital {
    background-color: ${VARIABLES.COLORS.GRAY_7};
    border: 1px solid ${VARIABLES.COLORS.GRAY_2};
    border-radius: ${VARIABLES.BORDER_RADIUSES.XS};
    padding: 8px 14px;

    h4 {
      color: ${VARIABLES.COLORS.BLUE_1};
      font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_MEDIUM};
      flex: none;
      margin-bottom: 1rem;
    }
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1700.98px) {
    .main-content {
      padding: 55px 0;
    }
  }

  @media all and (max-width: 1600.98px) {
    .main-content {
      padding: 50px 0;
    }
  }

  @media all and (max-width: 1440.98px) {
    .main-content {
      padding: 45px 0;
    }
  }

  /* Start max-width: '1439px'*/
  @media all and (max-width: ${VARIABLES.BREAKPOINTS.DESKTOP_SM_MAX}) {
    .supplier-list-wrapper {
    }
    .scoreboard {
      width: 80px;
      height: 80px;
    }

    .info-block {
      .label {
        flex: 0 0 120px;
      }
    }

    .supplier-header {
      margin-bottom: 10px;
    }

    .supplier-info {
      width: 85%;
    }

    .supplier-address {
      font-size: 12px;
    }
  }

  @media all and (max-width: 1366.98px) {
    .main-content {
      padding: 40px 0;
    }
  }

  @media all and (max-width: 1280.98px) {
    .main-content {
      padding: 30px 0;
    }

    /* .separate-line {
      left: 24%;
    } */

    /* .supplier-list-wrapper {
      width: 76%;
      padding-right: 20px;
    } */
  }

  @media all and (max-width: 1024.98px) {
    .main-content {
      padding: 20px 0;
    }

    /* .separate-line {
      left: 25%;
    } */

    /* .supplier-list-wrapper {
      width: 75%;
      padding-right: 15px;
    } */
  }
`
